import { themeHelpers } from '@subaio/utils'

import { defaultFontFamilies, defaultFonts, defaultSpacing } from './defaultStyles'
import { defaultButtonTheme, defaultInputTheme, defaultStatusTheme } from './defaultThemes'

export const theme = {
	fontFamilies: defaultFontFamilies,
	fonts: defaultFonts(defaultFontFamilies),

	font: {
		family: {
			header: 'sans-serif',
			base: 'sans-serif',
			code: 'monospace',
		},
	},

	spacing: defaultSpacing,

	color: {
		link: '#337AB7',
		text: '#5F6368',
		textHeader: '#202124',
		border: '#ADB1B2',
		primary: '#4499FF',
		danger: '#DF615F',
		textMuted: '#777',
		background: '#FFF',

		status: defaultStatusTheme,
		input: defaultInputTheme,
		button: defaultButtonTheme,
	},
}

// We cast the helpers to any to avoid type collisions in other projects
export const helpers = themeHelpers<typeof theme>(theme) as any
